import { useAppSelector } from '@/shared/model';

import { BannersFilters } from './BannersFilters';
import { SingleBanner } from './SingleBanner';

export const BannersContents = () => {
  const banners = useAppSelector((state) => state.banners.banners);

  return (
    <>
      <div className={'mx-auto flex w-[1280px] items-center justify-between'}>
        <h1 className={'text-[42px] font-medium leading-[48px] text-black '}>
          Баннеры
        </h1>
      </div>
      <BannersFilters />
      {banners.map((elem: any, i: number) => (
        <SingleBanner
          key={elem.id}
          id={elem.id}
          section={elem.place.title}
          title={elem.title}
          status={elem.status}
          format={elem.format}
          period={elem.period}
          isPromotional={elem.isPromotional}
          // onDelete={onDelete}
          isFirst={i === 0}
          isLast={i === banners.length - 1}
          index={i}
          itemsCount={banners.length}
          dateStart={elem.dateStart}
          dateEnd={elem.dateEnd}
        />
      ))}
    </>
  );
};
